import {useParams} from 'react-router-dom'

import styles from './ProjectAbout.module.scss'
import {Confirm, Button} from 'common/components'
import {useArchiveProject} from '..'

import {
  ProjectCard,
  BorrowerProjectFeedback,
  BorrowerProjectAboutIndicators,
  BorrowerProjectAboutDetails,
  useGetProject,
  isProjectRequest,
} from '..'

interface ArchiveProjectProps {
  projectUuid: string
  isRefetching: boolean
}

export default function BorrowerProjectAbout() {
  const params = useParams()
  const {data: project, isRefetching} = useGetProject(params.uuid)

  const canArchive =
    !project.archived &&
    (project.status === 'closed' || project.status === 'declined')

  return (
    <div className={styles.root}>
      <ProjectCard project={project} imgHeight={400}>
        {!isProjectRequest(project) && <BorrowerProjectFeedback />}
        {canArchive && (
          <ArchiveProject
            projectUuid={project.uuid}
            isRefetching={isRefetching}
          />
        )}
      </ProjectCard>
      <div>
        <BorrowerProjectAboutIndicators />
        <BorrowerProjectAboutDetails />
      </div>
    </div>
  )
}

const ArchiveProject = ({projectUuid, isRefetching}: ArchiveProjectProps) => {
  const {mutate: archiveProject, isMutating} = useArchiveProject(projectUuid)

  const handleConfirm = () => archiveProject()

  return (
    <div className={styles.archive}>
      <Confirm
        title="Are you sure you want to archive the project?"
        okText="archive"
        onConfirm={handleConfirm}
      >
        <Button block loading={isMutating} disabled={isRefetching}>
          archive project
        </Button>
      </Confirm>
    </div>
  )
}
